import React from "react";
import { useState, useEffect } from "react";
import { UseUserinfo } from "../../adapters/Requests";

function WelcomeBanner() {
  const useUserData = UseUserinfo();
  const { data } = useUserData;
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const getCurrentDate = () => {
      const date = new Date();
      const day = date.getDate();
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();
      let suffix = "";
      if (day === 1 || day === 21 || day === 31) {
        suffix = "st";
      } else if (day === 2 || day === 22) {
        suffix = "nd";
      } else if (day === 3 || day === 23) {
        suffix = "rd";
      } else {
        suffix = "th";
      }
      setCurrentDate(`${day}${suffix} ${month} ${year}`);
    };

    getCurrentDate();
  }, []);
  return (
    <div className="relative  rounded-sm overflow-hidden mb-0">
      {/* Background illustration */}
      <div
        className="absolute right-0 top-0 px-4 -mt-4 mr-16 pointer-events-none hidden xl:block"
        aria-hidden="true"
      ></div>
      <span className=" text-lg text-yellow-600"> {currentDate}</span>
      {/* Content */}
      <div className="relative card">
        {data && (
          <>
            <h1 className="text-lg md:text-lg text-slate-800 dark:text-slate-100 font-light mt-1">
              Hello {`${data.first_name} ${data.last_name}`}! 👋
            </h1>
            <p className="dark:text-indigo-200 hidden">
              Here you will find all your data and information
              {/* {` ${data.last_name}`} */}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default WelcomeBanner;
